(() => {
  const initMegaMenus = (root = document) => {
    const header = root.querySelector?.('.header-wrapper') || document.querySelector('.header-wrapper');
    const clusters = Array.from((root.querySelectorAll?.('[data-pedrocchi-mega-cluster]') || []));

    if (!clusters.length) return;

    const syncHeaderState = () => {
      const anyOpen = clusters.some((cluster) => cluster.querySelector('details.pedrocchi-mega-menu[open]'));
      header?.classList.toggle('pedrocchi-mega-menu-open', anyOpen);
    };

    const closeOtherMenus = (activeDetails) => {
      clusters.forEach((cluster) => {
        const details = cluster.querySelector('details.pedrocchi-mega-menu');
        if (!details || details === activeDetails) return;
        details.removeAttribute('open');
      });
    };

    clusters.forEach((cluster) => {
      if (cluster.dataset.pedrocchiMegaReady === 'true') return;
      cluster.dataset.pedrocchiMegaReady = 'true';

      const details = cluster.querySelector('details.pedrocchi-mega-menu');
      const toggle = details?.querySelector('summary');
      if (!details || !toggle) return;

      let closeTimer;
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        closeOtherMenus(details);
        details.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
        syncHeaderState();
      };

      const closeMenu = () => {
        details.removeAttribute('open');
        toggle.setAttribute('aria-expanded', 'false');
        syncHeaderState();
      };

      cluster.addEventListener('mouseenter', () => {
        if (canHover.matches) openMenu();
      });

      cluster.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        closeTimer = window.setTimeout(closeMenu, 110);
      });

      cluster.addEventListener('focusin', () => {
        window.clearTimeout(closeTimer);
      });

      cluster.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!cluster.contains(document.activeElement)) closeMenu();
        }, 0);
      });

      details.addEventListener('toggle', () => {
        if (details.open) closeOtherMenus(details);
        toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        syncHeaderState();
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-pedrocchi-mega-cluster]')) return;
      clusters.forEach((cluster) => cluster.querySelector('details.pedrocchi-mega-menu')?.removeAttribute('open'));
      syncHeaderState();
    });

    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      clusters.forEach((cluster) => cluster.querySelector('details.pedrocchi-mega-menu')?.removeAttribute('open'));
      syncHeaderState();
    });
  };

  const boot = () => initMegaMenus(document);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => initMegaMenus(event.target));
})();
